<vs-dialog #dialog [config]="{ dialogContainerClass: 'max-w-[600px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      icon: 'layers-three-01',
      iconTheme: 'primary',
      title: dimension?.id ? 'Edit Dimension' : 'Create Dimension',
      subtitle: dimension?.id
        ? 'Update the details of this dimension.'
        : 'Add a new dimension to define the structure of your rating matrix.'
    }"
  ></vs-dialog-header>

  <form [formGroup]="form" (ngSubmit)="save()">
    <vs-form-field
      appearance="responsive"
      [theme]="form.get('title')?.touched && form.get('title')?.invalid ? 'danger' : 'primary'"
      [config]="{
        label: 'Title',
        description: 'The name of this dimension (e.g., FeeType, Coverage, Class, Region, ProductType)'
      }"
    >
      <input vsInput type="text" formControlName="title" placeholder="Enter dimension title" />
      <span
        slot="hint"
        class="text-danger"
        *ngIf="form.get('title')?.touched && form.get('title')?.hasError('required')"
      >
        Title is required
      </span>
      <span slot="hint" class="text-danger" *ngIf="form.get('title')?.hasError('maxlength')">
        Title must be less than 255 characters
      </span>
    </vs-form-field>

    <vs-divider class="my-4"></vs-divider>

    <vs-form-field
      appearance="responsive"
      [theme]="form.get('description')?.touched && form.get('description')?.invalid ? 'danger' : 'primary'"
      [config]="{
        label: 'Description',
        description: 'Optional description for this dimension'
      }"
    >
      <textarea vsInput rows="3" formControlName="description" placeholder="Enter description (optional)"></textarea>
      <span slot="hint" class="text-danger" *ngIf="form.get('description')?.hasError('maxlength')">
        Description must be less than 255 characters
      </span>
    </vs-form-field>

    <vs-divider class="my-4"></vs-divider>

    <vs-form-field
      appearance="horizontal"
      class="[&>div>div:last-child]:min-w-[unset]"
      [config]="{
        label: 'Scalar Dimension',
        description: 'Enable for numeric ranges (e.g., age, quantity, mileage). Disable for discrete options (e.g., tier, coverage, region).'
      }"
    >
      <input vsInput type="checkbox" appearance="toggle" class="block ml-auto" formControlName="isScalar" />
    </vs-form-field>

    <vs-divider class="my-4"></vs-divider>

    <vs-form-field
      appearance="horizontal"
      class="[&>div>div:last-child]:min-w-[unset]"
      [config]="{
        label: 'Pricing Dimension',
        description: 'Enable if this dimension is used for pricing. Leave disabled for non-pricing uses (e.g. class guides, eligibility, or other business rules).'
      }"
    >
      <input vsInput type="checkbox" appearance="toggle" class="block ml-auto" formControlName="isPricing" />
    </vs-form-field>

    <div class="flex gap-2 mt-6">
      <button vs-button appearance="outline" class="flex-1" type="button" (click)="cancel()" [disabled]="saving">
        Cancel
      </button>
      <button vs-button theme="primary" class="flex-1" type="submit" [disabled]="saving || isSaveDisabled">
        <vs-icon slot="start" [class.animate-spin]="saving" [name]="saving ? 'refresh-cw-04' : 'save-01'"></vs-icon>
        {{ saving ? 'Saving...' : (dimension?.id ? 'Update' : 'Create') }}
      </button>
    </div>
  </form>
</vs-dialog>
